import { apiClient } from './api'

export type CardInfo = {
  last4: string | null
  brand: string | null
  exp_month: number | null
  exp_year: number | null
}

export type PaymentMethod = {
  id: string
  organization_id: string
  type: string // 'credit_card', 'invoice', 'credit_account'
  billing_mode: string // 'direct', 'postpaid'
  gateway: string | null // 'stripe', 'asaas', null
  is_default: boolean
  is_active: boolean
  card_info: CardInfo | null
  created_at: string
}

export type CreatePaymentMethodRequest = {
  type: string
  billing_mode: string
  gateway?: string | null
  asaas_customer_id?: string | null
  asaas_payment_method_id?: string | null
  card_last4?: string | null
  card_brand?: string | null
  card_exp_month?: number | null
  card_exp_year?: number | null
  is_default?: boolean
}

export type PaymentMethodListResponse = {
  payment_methods: PaymentMethod[]
  total: number
}

export const paymentMethodsApi = {
  // List all payment methods for current end customer
  listPaymentMethods: (): Promise<PaymentMethodListResponse> => {
    return apiClient.get('/api/v1/end-customer/payment-methods')
  },

  // Create new payment method
  createPaymentMethod: (data: CreatePaymentMethodRequest): Promise<PaymentMethod> => {
    return apiClient.post('/api/v1/end-customer/payment-methods', data)
  },

  // Set payment method as default
  setDefaultPaymentMethod: (paymentMethodId: string): Promise<PaymentMethod> => {
    return apiClient.post(`/api/v1/end-customer/payment-methods/${paymentMethodId}/set-default`)
  },

  // Deactivate payment method
  deactivatePaymentMethod: (paymentMethodId: string): Promise<void> => {
    return apiClient.delete(`/api/v1/end-customer/payment-methods/${paymentMethodId}`)
  },
}

export default paymentMethodsApi
